import TimerClock from '../TimerClock'

export default function InfiniteTimer({
  timerSeconds,
  backgroundImg,
  totalIntervals,
  intervalsLeft,
}) {
  return (
    <>
      <TimerClock
        timerSeconds={timerSeconds}
        backgroundImg={backgroundImg}
        totalIntervals={totalIntervals}
        intervalsLeft={intervalsLeft}
      />
    </>
  )
}
